import React from 'react';
import LinksPostPurchaseMerchantHeader from './links/LinksPostPurchaseMerchantHeader';
import CartHeader from 'cart/views/CartHeader';
import ProductsPostPurchaseMerchantHeader from './products/ProductsPostPurchaseMerchantHeader';
import PostPurchaseResponse from './post-purchase/PostPurchaseResponse';
import Modal, {
  ModalContent, ModalClose, contentWrapperStyles,
} from 'views/Modal';
import { Modes } from 'cart/config';

import {
  isRunningInIframe,
} from 'config/utils';

const PostPurchase = ({
  backdropStyle,
  responseType,
  isCartOrder,
  isPaymentPopupOpen,
  modalContentContainerStyle,
  shouldShowPaymentOptionsDirectlyOnRetry,
  postPurchase,
  _wrap,
  _renderBrandFooter,
  onRequestClose,
}) => {
  document.body.style.background = 'none';
  return (
    <Modal
      aria-labelledby='payments-modal'
      backdropStyle={backdropStyle}
      show={isPaymentPopupOpen}
      >
      { _wrap(
          <ModalContent
            isClosable={false}
            handleFullScreenScroll={false}
            style={{ ...modalContentContainerStyle }}>
            { responseType == 'link' || responseType == 'instapay' ?
              <LinksPostPurchaseMerchantHeader
                sellerAvatar={postPurchase.payment.seller.avatar}
                fullName={postPurchase.payment.seller.fullname}
                /> :
              isCartOrder ?
              <div style={{ background: '#fff', borderRadius: '4px 4px 0 0' }}>
                <CartHeader
                  purchased={postPurchase.status === 'success'}
                  mode={Modes.FULL}
                  totalItems={postPurchase.payment.subOrders.length}
                />
              </div> :
              <ProductsPostPurchaseMerchantHeader
                sellerAvatar={postPurchase.payment.seller.avatar}
                fullName={postPurchase.payment.seller.fullname}
                preview={postPurchase.payment.offer.preview}
                title={postPurchase.payment.offer.title}
                />
            }
            <PostPurchaseResponse
              isCartOrder={isCartOrder}
              shouldShowPaymentOptionsDirectlyOnRetry={shouldShowPaymentOptionsDirectlyOnRetry}
              {...postPurchase}
              />

            { _renderBrandFooter('light') }

            { isRunningInIframe() ?
              <ModalClose
                className="payments--close"
                onRequestClose={() => {
                  onRequestClose();
                }}/> :
                null
            }
          </ModalContent>, 'is--embed-iframe', contentWrapperStyles
        )
      }
    </Modal>
  );
};

export default PostPurchase;



// WEBPACK FOOTER //
// ./src/payments/views/PostPurchase.js